/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const Incognito = (
	<SVG
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 22"
		fill="none"
		className="pum-icon pum-icon--incognito"
	>
		<Path
			d="M15.5 21C17.433 21 19 19.433 19 17.5C19 15.567 17.433 14 15.5 14C13.567 14 12 15.567 12 17.5C12 19.433 13.567 21 15.5 21Z"
			stroke="#000000"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<Path
			d="M4.5 21C6.433 21 8 19.433 8 17.5C8 15.567 6.433 14 4.5 14C2.567 14 1 15.567 1 17.5C1 19.433 2.567 21 4.5 21Z"
			stroke="#000000"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<Path
			d="M1 11H19L16 7H4L1 11Z"
			stroke="#000000"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<Path
			d="M4 7L5 1H15L16 7"
			stroke="#000000"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<Path
			d="M12.1 16.713C11.4991 16.2506 10.7622 15.9999 10.004 15.9999C9.24577 15.9999 8.50885 16.2506 7.90796 16.713"
			stroke="#000000"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</SVG>
);

export default Incognito;
